/// <amd-module name="Reporting/BoardsCommon/LightboxReportGuidedTourUtility" />
import * as React from "react";
import { saveUserBubbleSettings } from "Reporting/BoardsCommon/ReportGuidedTourUtility";
import * as Resources from "Reporting/BoardsCommon/Resources";
import { ObservableValue } from "VSS/Core/Observable";
import { format } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { Button } from "VSSUI/Button";
import { Observer } from "VSSUI/Observer";
import { ITeachingBubbleProps, TeachingBubble } from "VSSUI/TeachingBubble";
import { Location } from "VSSUI/Utilities/Position";

export interface LightboxReportBubbleProps {
    title?: string;
    text?: string;
}

/*
 * This is used to pass the text to be displayed in the respective teaching bubble on the lightbox
 */
export interface LightboxReportGuidedTourUtilityProps {
    reportKey: string;
    tourBubble?: LightboxReportBubbleProps;
}

/*
 * This class manages an instance of the guided tour teaching bubble for lightbox reports
 * The collection level helps track if user has seen the tour before for default loading scenario
 */
export class LightboxReportGuidedTourUtility {
    private tutorialDismissed = -1;
    // Stores the array of teaching bubbles
    private teachingBubbleTourProps: ITeachingBubbleProps;
    // Stores the index of current active bubble
    private activeTourStep = new ObservableValue<number>(this.tutorialDismissed);

    constructor(
        private pageContext: IVssPageContext,
        private tourUtilityProps: LightboxReportGuidedTourUtilityProps,
        private dismissBubble: () => void
    ) {}

    public titleBubbleCallback = (element: HTMLDivElement) => {
        this.teachingBubbleTourProps = {
            anchorElement: element,
            anchorOrigin: { horizontal: Location.center, vertical: Location.end },
            title: this.tourUtilityProps.tourBubble!.title,
            text: this.tourUtilityProps.tourBubble!.text,
            onDismiss: this.dismissTour
        };
        this.activeTourStep.value = 0;
    };

    public render(showTeachingBubble?: boolean): JSX.Element {
        return (
            <>
                {showTeachingBubble && (
                    <Observer activeBubble={this.activeTourStep}>
                        {(props: { activeBubble: number }) => {
                            return props.activeBubble !== this.tutorialDismissed ? <TeachingBubble {...this.teachingBubbleTourProps} /> : null;
                        }}
                    </Observer>
                )}
            </>
        );
    }

    private dismissTour = () => {
        this.dismissBubble();
        this.activeTourStep.value = this.tutorialDismissed;
        saveUserBubbleSettings(this.pageContext, this.tourUtilityProps.reportKey);
        this.render(false);
    };
}

export function getInfoIcon(titleBubbleCallback: any, toggleTeachingBubble: any, showIcon: boolean, reportTitle: string): JSX.Element | null {
    if (!showIcon) {
        return null;
    }

    return (
        <span ref={titleBubbleCallback}>
            <Button
                className="boards-report-info-icon subtle"
                ariaLabel={format(Resources.InfoIcon, reportTitle)}
                iconProps={{ iconName: "Unknown" }}
                onClick={toggleTeachingBubble}
            />
        </span>
    );
}
